import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';
import { fleetAddressSchema } from './fleet-address.schema';

export const fleetVehicleInformationSchema = z.object({
  deviceId: z.string(),
  appVersion: z.string().nullable(),
  dataVersion: z.string().nullable(),
  osType: z.string().nullable(),
  osVersion: z.string().nullable(),
  deviceModel: z.string().nullable(),
  installedMapRegions: z.string().array().nullable(),
  lastCommunicationRequest: z.string().nullable(),
  lastConnected: z.string().nullable(),
  address: fleetAddressSchema.nullable(),
  coords: z
    .object({
      lat: z.number(),
      lon: z.number(),
    })
    .nullable(),
  lastStoredTimeStamp: coercedDate.nullable(),
});

export type FleetVehicleInformation = z.infer<
  typeof fleetVehicleInformationSchema
>;
